'use strict';
var globalThis = require('../internals/global-this');

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/environment-user-agent.js
// module id = 341
// module chunks = 22